exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".stock-item-td{color:#6c7293}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./App/Components/PM/PMDetail.vue
// module id = 1106
// module chunks = 0